@if (selectedTeam$ | async; as selectedTeam) {
  <div class="gb-dialog-header">
    <h1 [translate]="title" [translateParams]="{ teamName: selectedTeam.name }"></h1>
    <button mat-icon-button mat-dialog-close>
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>
  <div class="gb-dialog-content">
    <gb-team-profiles-list
      [isViewMode]="isViewMode"
      (selectedProfilesChangedEvent)="onSelectedProfilesChanged($event)"
    ></gb-team-profiles-list>
  </div>
  <div [hidden]="!selectedProfilesCount" class="gb-dialog-actions-container">
    <span
      [translate]="selectedProfilesCount === 1 ? 'TEAMS.EDIT.PROFILE_SELECTED' : 'TEAMS.EDIT.PROFILES_SELECTED'"
      [translateParams]="{ count: selectedProfilesCount }"
      class="selected-count"
    ></span>
    <div class="buttons-container">
      @if (isAddMode) {
        <button mat-flat-button (click)="submit()" [loaded]="editCreateLoaded$ | async">
          <span translate="TEAMS.ADD_PROFILE"></span>
        </button>
      } @else {
        <button mat-flat-button (click)="showConfirmation(selectedTeam)" [loaded]="editCreateLoaded$ | async">
          <span translate="TEAMS.EDIT.REMOVE_BUTTON_LABEL"></span>
        </button>
      }
    </div>
  </div>
}
